import { useCallback } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useChat } from '../contexts/ChatContext';
import { useNotifications } from '../contexts/NotificationContext';

// Track app initialization state from all critical contexts
// Only trigger global loading screen during initial app bootstrap
export const useAppInitializer = () => {
  const { user, loading: authLoading } = useAuth();
  const { initialLoading: chatInitialLoading } = useChat();
  const { loading: notificationsLoading } = useNotifications();

  // App is initializing while any critical context is loading
  // Only show global loading screen during INITIAL load, not when switching chats
  const isInitializing = user
    ? (authLoading || chatInitialLoading || notificationsLoading)
    : authLoading;

  const retry = useCallback(() => {
    // Force a re-render by toggling a state
    window.location.reload();
  }, []);

  return { isInitializing, retry };
};

export default useAppInitializer;
